
export class RelatedContentModule {
    constructor() {
        if ($(".related-content").length > 0 ) {
            this.init(); 
        }       
    }

    init() {
        let _this = this;
        
        $(window).on('load', function () {
            if ($(".related-content")) {
                _this.registerClick();
            }
        });
    }

    registerClick() {
        $('.related-content .more').on('click', function (e) {
            e.preventDefault();
            $(this).text($(this).text() == 'Show more topics' ? 'Show fewer topics' : 'Show more topics');
            $(this).toggleClass('active');
            $('.related-content li.extra').toggleClass('hidden');
        });
    }
}

